import './leasing-card-mobile.scss';

import { LEASING_STATUSES } from '@/constants';

type TProps = {
  title: string | null;
  subtitle: string | null;
  statusName: string;
  statusCode: string;
};

const LeasingCardMobile: React.FC<TProps> = ({
  title,
  subtitle,
  statusName,
  statusCode
}) => {
  const statusColors =
    LEASING_STATUSES[statusCode as keyof typeof LEASING_STATUSES];
  return (
    <div className="leasing-card-mobile">
      <div className="leasing-card-mobile__info">
        <span className="leasing-card-mobile__name">{title}</span>
        <div className="leasing-card-mobile__details">{subtitle}</div>
      </div>

      <div className="leasing-card-mobile__status">
        <span className="leasing-card-mobile__status-badge">
          <p className="leasing-card-mobile__status-name">
            <span
              className="leasing-card-mobile__circle"
              style={{
                backgroundColor: statusColors?.bgColor
              }}
            ></span>
            {statusName || 'Неизвестный статус'}
          </p>
        </span>
      </div>
    </div>
  );
};

export default LeasingCardMobile;
